import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
// import { BrowserRouter } from 'react-router-dom';
import PortfolioWebsite from './PortfolioWebsite';


// Initialize Google Analytics
ReactGA.initialize('G-9JTYRXXB7C'); // Replace G-XXXXXXXXXX with your actual Measurement ID

// Create a function to send pageviews
const sendPageview = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

// Function to handle link clicks
const handleLinkClick = (event) => {
  const link = event.currentTarget;
  const url = link.href;

  ReactGA.event({
    category: 'Link',
    action: 'click',
    label: url,
  });

  // We're not preventing default behavior or manually navigating
  // This allows the link to work normally
};

// Add event listeners to all links
const addLinkClickListeners = () => {
  const links = document.getElementsByTagName('a');
  for (let i = 0; i < links.length; i++) {
    if (!links[i].getAttribute('data-ga-tracked')) {
      links[i].addEventListener('click', handleLinkClick);
      links[i].setAttribute('data-ga-tracked', 'true');
    }
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PortfolioWebsite />
  </React.StrictMode>
);

// Send initial pageview
sendPageview(window.location.pathname + window.location.search);

// If you want to track navigation changes without react-router
window.addEventListener('popstate', () => {
  sendPageview(window.location.pathname + window.location.search);
});

// Add link click listeners after the DOM is fully loaded
document.addEventListener('DOMContentLoaded', addLinkClickListeners);

// Use MutationObserver to handle dynamically added links
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      addLinkClickListeners();
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });